import http from '@/core/http'
// import { map } from 'lodash'

const state = {
  itens: [],
  totalItens: 0
}

const actions = {
  obterAfiliados: async ({commit}, payload) => {
    const result = await http.get('/afiliados-statisticas', { params: { ...payload } })
    commit('LISTA_AFILIADOS', result.data)
    return Promise.resolve(result.data[0])
  }
}

const mutations = {
  'LISTA_AFILIADOS' (state, payload) {
    state.itens = payload.resultMap
    state.totalItens = payload[1]
  }
}

const getters = {
  listaItens: state => state.itens,
  totalItens: state => state.totalItens,
}

export default { namespaced: true, state, actions, mutations, getters }